<template>
  <div class="animated fadeIn">
    <div>
      <component-header
        :title="`${
          partnerAllData && partnerAllData.authentication
            ? partnerAllData.authentication.userName
            : ''
        } - View Subscription`"
        :isLoading="isloading"
        @reload-data="getPartnerSubcriptionListData"
        :hasSearch="false"
        :hasback="true"
        @back-press="goToViewPage"
        @create-press="goToCreatePage"
      />
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            :dark="false"
            :hover="true"
            :striped="false"
            :bordered="true"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="subscriptionItemList"
            :fields="subscriptionColumns"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            show-empty
          >
            <template slot-scope="data" slot="action">
              <b-button
                @click="deletePlan(data.item)"
                size="sm"
                class="mr-2 my -0 main-navigation-button"
                variant="outline-primary"
              >
                Cancel
              </b-button>
            </template>
            <template slot="empty">
              <div v-if="isloading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>

            <template slot="status" slot-scope="data">
              <div v-if="data.item.status == 'ACTIVE'">
                <img class="mr-1" src="img/Ellipse63.png" alt="" /> Active
              </div>
              <div v-if="data.item.status == 'INACTIVE'">
                <img class="mr-1" src="img/Ellipse6.png" alt="" /> Inactive
              </div>
              <div v-if="data.item.status == 'PENDING'">
                <img class="mr-1" src="img/orangeStatus.png" alt="" />Pending
              </div>
            </template>
          </b-table>
        </div>
        <div class="float-right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="subscriptionItemList.length"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentHeader";
import moment from "moment";
export default {
  name: "ViewSubscription",
  data() {
    return {
      isloading: false,
      currentPage: 1,
      perPage: 8,
      subscriptionColumns: [
        {
          key: "name",
        },
        {
          key: "startDate",
        },
        {
          key: "invoicedUpto",
        },
        {
          key: "nextBillDate",
        },
        {
          key: "lastBillDate",
        },
        {
          key: "rate",
        },
        {
          key: "description",
        },
        {
          key: "status",
        },
        {
          key: "action",
        },
      ],
    };
  },
  components: {
    ebButton,
    ComponentHeader,
  },
  computed: {
    ...mapGetters({
      subscriptionList: "subscription/GetSubscriptionList",
      partnerAllData: "partner/GetPartnerData",
      partnerSubscribedList: "subscription/GetSubscriptionPartnerList",
    }),
    subscriptionItemList() {
      let data = this.partnerSubscribedList;
      let subscriptionList = this.subscriptionList;

      let subscribedList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map(obj => {
          try {
            let selectedPlan = subscriptionList.filter(element => {
              return element._id == obj.plan;
            });

            let arrObj = {
              _id: obj._id,
              name: selectedPlan[0].planName,
              startDate: this.getProperDate(obj.activationDate),
              chargeTo: this.getProperDate(obj.chargeTo),
              invoicedUpto: this.getProperDate(obj.chargeTo),
              nextBillDate: this.getProperDate(obj.nextBillDate),
              lastBillDate: this.getProperDate(obj.lastBillDate),
              rate: this.cedencePriceSet(obj),
              description: selectedPlan[0].planDescription,
              status: obj.status,
              planUser: obj.user,
              restData: obj,
            };
            subscribedList.push(arrObj);
          } catch (err) {}
        });
        return subscribedList.sort(
          (a, b) =>
            new Date(b.restData.updatedAt) - new Date(a.restData.updatedAt)
        );
      } else {
        return [];
      }
    },
  },

  methods: {
    goToViewPage() {
      this.$router.push({
        name: "PartnerView",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    goToCreatePage() {
      this.$router.push({
        name: "Create Subscription",
        params: { id: this.$route.params.id },
      });
    },
    async deletePlan(data) {
      let payload = {
        user: data.planUser,
        subscription: data._id,
      };
      this.$swal({
        title: "Cancel this Subscription?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("subscription/partnerSubscriptionDelete", payload)
            .then(result => {
              console.log("result", result);
              this.getPartnerSubcriptionListData();
              this.$swal({
                title: "Success",
                text: "Subscription Canceled Successfully!",
                type: "success",
              });
            })
            .catch(err => {
              console.log("err", err);
            });
        }
      });
    },

    cedencePriceSet(obj) {
      if (obj.pricing.cadence == "EVENT") {
        return (obj.pricing.price * 100).toFixed(2);
      } else {
        return obj.pricing.price.toFixed(2);
      }
    },
    async getPartnerSubcriptionListData() {
      this.isloading = true;
      await this.$store
        .dispatch("subscription/getSubscriptionPartner", {
          id: this.partnerAllData._id,
          data: {},
        })
        .then(data => {
          if (data.message) {
            this.$toasted.error(data.message);
            this.isloading = false;
          }
          this.isloading = false;
        })
        .catch(err => {
          this.isloading = false;
        });
    },
    getProperDate(data) {
      if (data != null) {
        let date = new Date(data);

        return moment(String(date)).format("DD/MM/YYYY");
      } else {
        return "Unavailable";
      }
    },
  },
  async mounted() {
    this.isloading = true;
    this.$store.dispatch(
      "partner/fetchPartnerDetails",
      this.$route.params.parentId || this.$route.params.id
    );
    try {
      await this.$store
        .dispatch("subscription/getSubscriptionPartner", {
          id: this.partnerAllData._id || this.$route.params.id,
          data: {},
        })
        .then(result => {})
        .catch(err => {});
    } catch (error) {
      console.log(error);
    }

    await this.$store.dispatch("subscription/fetchSubscriptionList");
    this.isloading = false;
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
